
//Here's the api connector to communicate with the wordpress
//https://localhost/cms-service/index.php/wp-json/v1/home/id/23

import { get } from '@kit/utils/APIV1.js'

export const about = async() => {
  return get(`about/id/455`)
}